import { NgModule } from "@angular/core";
import { CalendarComponent } from "./calendar.component";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { MoodComponent } from "./mood/mood.component";
import { MoodFiltersComponent } from "./mood-filters/mood-filters.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TmTeamSelectComponent } from "@teammood/team";
import { AnnouncementComponent } from "../shared/ui/announcement/announcement.component";
import { MoodsDistributionBarComponent } from "../timeline/moods-distribution-bar/moods-distribution-bar.component";
import { TmDateRangePickerComponent } from "@teammood/shared/ui/date-range-picker";

@NgModule({
    declarations: [
        CalendarComponent
  ],
    imports: [
        MoodComponent,
        MoodFiltersComponent,
        TmTeamSelectComponent,
        AnnouncementComponent,
        MoodsDistributionBarComponent,
        TmDateRangePickerComponent,
        CommonModule,
        FormsModule, 
        ReactiveFormsModule,
        TranslateModule,
    ],
})
export class TmCalendarModule{
}